import { BaseError } from './base/base-error';

export class CancelConfirmationError extends BaseError {
  name = 'CancelConfirmationError';
}

